import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=d40067a0&scoped=true"
import script from "./Sensor.vue?vue&type=script&lang=js"
export * from "./Sensor.vue?vue&type=script&lang=js"
import style0 from "./Sensor.vue?vue&type=style&index=0&id=d40067a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40067a0",
  null
  
)

export default component.exports